module.exports = __webpack_public_path__ + "static/media/Gotham-Medium.6bf5dc75.woff2";